module.exports = __webpack_public_path__ + "static/media/example_chart_report_hr.529939ad.png";